__turbopack_context__.v({
  "cast": "container-module-scss-module__Fx4CrG__cast",
  "centered": "container-module-scss-module__Fx4CrG__centered",
  "container": "container-module-scss-module__Fx4CrG__container",
  "default": "container-module-scss-module__Fx4CrG__default",
  "illustration": "container-module-scss-module__Fx4CrG__illustration",
  "jobs": "container-module-scss-module__Fx4CrG__jobs",
  "left": "container-module-scss-module__Fx4CrG__left",
  "list": "container-module-scss-module__Fx4CrG__list",
  "media": "container-module-scss-module__Fx4CrG__media",
  "narrow": "container-module-scss-module__Fx4CrG__narrow",
  "tiles": "container-module-scss-module__Fx4CrG__tiles",
  "wide": "container-module-scss-module__Fx4CrG__wide",
  "xWide": "container-module-scss-module__Fx4CrG__xWide",
});
